export enum FormDataFields {
  IMAGE = 'logo',
  IMAGE_TYPE = 'type',
}
